import {
    ProductShippingService,
    productShippingServiceDecoder
} from './ProductShippingService'
import {
    ParcelWithDetails,
    parcelWithPositionsDecoder
} from './ParcelWithDetails'
import {array, Decoder, field, object} from 'json-bouncer'
import {OpenPosition, openPositionDecoder} from './OpenPosition'

export interface ProductShippingServiceForOrder {
    readonly productShippingService: ProductShippingService
    readonly openPositions: OpenPosition[]
    readonly parcelsWithDetails: ParcelWithDetails[]
}

export function productShippingServiceForOrderDecoder(): Decoder<ProductShippingServiceForOrder> {
    return object({
        productShippingService: field('productShippingService', productShippingServiceDecoder()),
        openPositions: field('openPositions', array(openPositionDecoder())),
        parcelsWithDetails: field('parcelsWithDetails', array(parcelWithPositionsDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductShippingServiceForOrder.ts